import { secondaryButtonClass } from './ui'

export default function GoogleSignInButton() {
  const token = typeof document === 'undefined'
    ? ''
    : document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''

  return (
    <>
      <div className="my-5 flex items-center gap-3 text-xs text-muted" aria-hidden="true">
        <span className="h-px flex-1 bg-line" />or<span className="h-px flex-1 bg-line" />
      </div>
      <form method="post" action="/auth/google_oauth2">
        <input type="hidden" name="authenticity_token" value={token} />
        <button type="submit" className={`${secondaryButtonClass} w-full`}>Continue with Google</button>
      </form>
    </>
  )
}
